import { AffectedStaffEndOfStayReport } from '../../lib/types/models/affectedStaff/affected-staff-end-of-stay-report'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffEndOfStayReport(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.getAffectedStaffEndOfStayReport.url, {
        id: affectedStaffId
      })
    )
    .get<AffectedStaffEndOfStayReport>()
}
